import { useTranslation } from 'react-i18next';

import { Badge, BadgeColor } from 'components/Display/Badge/Badge';
import { Button } from 'components/Form/Button/Button';
import { MenuButton, MenuButtonOption } from 'components/MenuButton';

import { ActionConfig, MessageV2DTO } from '../types';

type PrimaryActionProps = {
  action: ActionConfig | null;
  fromDocument: MessageV2DTO;
};

export const PrimaryAction = ({ action, fromDocument }: PrimaryActionProps) => {
  const { t } = useTranslation();

  if (!action) {
    return null;
  }

  const triggerContent = <>{t(action.menuTitle || action.label)}</>;

  if (action.subActions) {
    return (
      <MenuButton
        className="ml-2"
        variant="primary"
        text={triggerContent}
        size="base"
        analyticsId="transactions:primary_actions"
      >
        {action.subActions.map((subAction) => (
          <MenuButtonOption
            analyticsId={subAction.analyticsId}
            key={subAction.label}
            onClick={() => subAction.onClick(fromDocument)}
            className="max-w-72"
          >
            <span className="space-y-2">
              <div className="flex justify-between gap-2">
                <span>{subAction.label}</span>
                {subAction.badge && <Badge color={BadgeColor.purple}>{t(subAction.badge)}</Badge>}
              </div>
              {subAction.description && (
                <span className="block text-sm font-normal text-gray-500">
                  {typeof subAction.description === 'function'
                    ? subAction.description(fromDocument)
                    : t(subAction.description)}
                </span>
              )}
            </span>
          </MenuButtonOption>
        ))}
      </MenuButton>
    );
  }

  return (
    <Button
      className="ml-2"
      variant="primary"
      onClick={() => action.onClick(fromDocument)}
      testId="ActionButtonPrimaryAction"
      analyticsId={action.analyticsId ?? 'transactions:primary_action'}
      loading={action.loading}
      LeftIcon={action.LeftIcon}
    >
      {triggerContent}
    </Button>
  );
};
